module.exports = __webpack_public_path__ + "static/media/3-iron.646a15e8.png";